import { Box, styled } from '@mui/material';

export const SummaryFieldWrapper = styled(Box)<{ withBorder?: boolean }>(({ theme, withBorder }) => ({
	borderBottom: withBorder ? `2px solid ${theme.palette.grey[400]}` : 0,
	':last-child': { borderBottom: 0 },
}));
